// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1BuIV","productName":"Table_productName__vGRf2"};